import React from 'react';
import { Space } from 'antd';
import EditLabTestButton from './EditLabTestButton';

const ActionsColumn = ({ columnData, onUpdateLabTest, getDetailInfo }) => (
  <Space>
    <EditLabTestButton
      columnData={columnData}
      onUpdateLabTest={onUpdateLabTest}
      getDetailInfo={getDetailInfo}
    />
  </Space>
);
export default ActionsColumn;
